export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const SIGNUP_PASSWORD_MIN_LENGTH = 6;
const SIGNUP_PASSWORD_CAPITAL = /[A-Z]/;
const SIGNUP_PASSWORD_SPECIAL = /[^A-Za-z0-9]/;

export const SIGNUP_PASSWORD_REQUIREMENTS = [
  {
    id: 'minLength',
    label: 'At least 6 characters',
  },
  {
    id: 'capitalLetter',
    label: 'One capital letter',
  },
  {
    id: 'specialCharacter',
    label: 'One special character',
  },
];

export function isValidEmail(value) {
  return EMAIL_REGEX.test(String(value || '').trim());
}

export function normalizeEmail(value) {
  return String(value || '').trim().toLowerCase();
}

/**
 * Password rules for roi-tool signup: 6+ characters, a capital letter,
 * and a special character (any non-alphanumeric).
 * @param {string} password
 * @returns {{ minLength: boolean, capitalLetter: boolean, specialCharacter: boolean }}
 */
export function getSignupPasswordRequirements(password) {
  const value = String(password || '');
  return {
    minLength: value.length >= SIGNUP_PASSWORD_MIN_LENGTH,
    capitalLetter: SIGNUP_PASSWORD_CAPITAL.test(value),
    specialCharacter: SIGNUP_PASSWORD_SPECIAL.test(value),
  };
}

export function isValidSignupPassword(password) {
  const requirements = getSignupPasswordRequirements(password);
  return (
    requirements.minLength &&
    requirements.capitalLetter &&
    requirements.specialCharacter
  );
}

export function getSignupPasswordError(password) {
  const requirements = getSignupPasswordRequirements(password);
  if (!requirements.minLength) {
    return 'Password must be at least 6 characters.';
  }
  if (!requirements.capitalLetter) {
    return 'Password must include a capital letter.';
  }
  if (!requirements.specialCharacter) {
    return 'Password must include a special character.';
  }
  return '';
}
